import { useContext } from "react";
import { AdminPanelUIContext } from "../context/AdminPanelUIContext";

export function useAdminPanelUI() {
    const context = useContext(AdminPanelUIContext);

    if(context == undefined)
        throw new Error("AdminPanelUIContext debe ser usado dentro de AdminPanelUIProvider.");

    return context;
}